// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YDvXF","clinicsSelect":"styles_clinicsSelect__13Sp2"};